import React from 'react';
import { Form } from 'react-bootstrap';
import { FieldValues, UseFormRegister } from 'react-hook-form';
import { InputRadioContainer } from '../styles';

interface InputRadioProps extends React.HTMLProps<HTMLInputElement> {
  label?: string;
  name: string;
  register: UseFormRegister<FieldValues>;
  isError: boolean;
  colorLabel?: string;
  color?: string;
}

export const InputRadio: React.FC<InputRadioProps> = ({
  label = '',
  name,
  register,
  isError,
  colorLabel,
  color = '#0052cc',
  ...rest
}) => {
  return (
    <InputRadioContainer color={color}>
      <input id={label} {...register(name)} type="radio" {...rest} />
      <Form.Label
        style={{ color: colorLabel }}
        className="form-label"
        htmlFor={label}
      >
        {label}
      </Form.Label>
    </InputRadioContainer>
  );
};
